import React from 'react';
import Grid from '@material-ui/core/Grid';

const PrivacyPolicyPage = () => {
  return (
    <Grid container className="privacy-policy-page" dir="ltr" justifyContent="center">
      <Grid item xs={12} className="privacy-hero" style={{ marginBottom: 20 }}>
        <h1>Privacy Policy</h1>
        <p>We respect your privacy and protect your personal information.</p>
      </Grid>
      <Grid item xs={12} className="privacy-content">
        <div className="privacy-card">
          <p>
            Your privacy is important to us. We are committed to protecting your personal information and using it transparently and responsibly.
            This Privacy Policy explains how we collect, use, and protect your data when you use our application.
          </p>

          <h3>Information We Collect</h3>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Usage data (such as activity logs within the app)</li>
            <li>Location data (GPS)</li>
            <li>User-uploaded photos</li>
          </ul>

          <h3>How We Use Your Information</h3>
          <p>We use the collected data for the following purposes:</p>
          <ul>
            <li>To provide and improve our services</li>
            <li>To communicate with you when necessary (e.g., support, updates)</li>
          </ul>
          <p>
            Location data and photos are used exclusively for managing and tracking attendance within the app. This data helps:
          </p>
          <ul>
            <li>Verify your physical location during check-in and check-out</li>
            <li>Enhance the accuracy of attendance reports</li>
          </ul>
          <p>
            We do not use your location or photos for marketing purposes or share them with third parties.
          </p>

          <h3>Data Sharing</h3>
          <ul>
            <li>Compliance with legal obligations</li>
            <li>With your explicit consent</li>
            <li>
              With trusted service providers who help us operate the app, subject to strict confidentiality agreements
            </li>
          </ul>

          <h3>Data Security</h3>
          <p>
            We implement appropriate technical and organizational measures to safeguard your personal information against unauthorized
            access, alteration, disclosure, or destruction.
          </p>

          <h3>Your Rights</h3>
          <ul>
            <li>You can access, update, or delete your personal data at any time by contacting us.</li>
            <li>
              You can disable location sharing through your device settings, but doing so may affect the functionality of the attendance
              feature in the app.
            </li>
          </ul>

          <h3>Changes to This Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. Any significant changes will be communicated through the app or by email.
          </p>

          <h3>Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:{' '}
            <a href="mailto:Dawaunited@gmail.com">Dawaunited@gmail.com</a>
          </p>

          <footer className="privacy-footer">
            © {new Date().getFullYear()} Dawa. All rights reserved.
          </footer>
        </div>
      </Grid>
    </Grid>
  );
};

export default PrivacyPolicyPage;


